// Overrides the static favicon <link> in public/index.html with the
// CMS-managed one (Settings → Logo → Favicon), once it's loaded — so admins
// can change the favicon without a code/asset change or redeploy.
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

const SiteFavicon = () => {
  const favicon = useSelector((s) => s.settings?.logo?.storefront_favicon);
  if (!favicon) return null;

  return (
    <Helmet>
      <link rel="icon" href={favicon} />
    </Helmet>
  );
};

export default SiteFavicon;
